import {FETCH_NEWS, LOAD_EDIT_NEWS_DATA, OPEN_NEWS_MODAL,UPDATE_NEWS_IMAGE} from 'ActionsNews';

export function fetchNews(state = [], action) {
  switch (action.type) {
    case FETCH_NEWS:
      return action.payload;
    default:
      return state;
  }
}

export function fetchNewsItem(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_NEWS_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function openNewsPopup(state = [], action){
  switch (action.type) {
    case OPEN_NEWS_MODAL:
      return action.payload.showModal;
    default:
      return state;
  }
}

export function newsImageReducer(state = null, action){
  switch (action.type) {
    case UPDATE_NEWS_IMAGE:
      return action.payload;
    default:
    return state;
  }
}
